import moment from 'moment';

const YESTERDAY = [
  moment().subtract(1, 'days'),
  moment().subtract(1, 'days')
];
const LAST_7_DAYS = [
  moment().subtract(7, 'days'),
  moment().subtract(1, 'days')
];
const THIS_WEEK = [
  moment().startOf('week').
    add(1, 'day'),
  moment().endOf('week').
    add(1, 'day')
];
const LAST_WEEK = [
  moment().subtract(1, 'week').
    startOf('week').
    add(1, 'day'),
  moment().subtract(1, 'week').
    endOf('week').
    add(1, 'day')
];
const THIS_MONTH = [
  moment().startOf('month'),
  moment().endOf('month')
];
const LAST_MONTH = [
  moment().subtract(1, 'month').
    startOf('month'),
  moment().subtract(1, 'month').
    endOf('month')
];

export default {
  YESTERDAY,
  LAST_7_DAYS,
  THIS_WEEK,
  LAST_WEEK,
  THIS_MONTH,
  LAST_MONTH
};
